const PageSkeleton = () => {
  return (
    <div className="p-4 pb-24 animate-pulse">
      {/* Header skeleton */}
      <div className="mb-6">
        <div className="h-8 bg-tg-secondary rounded-lg w-48 mb-2"></div>
        <div className="h-4 bg-tg-secondary rounded-lg w-64"></div>
      </div>

      {/* Cards skeleton */}
      <div className="grid grid-cols-3 gap-3 mb-6">
        {[1, 2, 3].map((i) => (
          <div key={i} className="bg-tg-secondary rounded-xl p-4">
            <div className="h-3 bg-gray-700 rounded w-20 mb-2"></div>
            <div className="h-6 bg-gray-700 rounded w-24"></div>
          </div>
        ))}
      </div>

      {/* List skeleton */}
      <div className="space-y-3">
        {[1, 2, 3, 4].map((i) => (
          <div key={i} className="bg-tg-secondary rounded-xl p-4">
            <div className="flex items-start gap-4">
              <div className="w-12 h-12 bg-gray-700 rounded-lg"></div>
              <div className="flex-1">
                <div className="h-4 bg-gray-700 rounded w-3/4 mb-2"></div>
                <div className="h-3 bg-gray-700 rounded w-full mb-2"></div>
                <div className="h-3 bg-gray-700 rounded w-2/3"></div>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default PageSkeleton;

